import { render, staticRenderFns } from "./AppSidebarItem.vue?vue&type=template&id=32c7a332&"
import script from "./AppSidebarItem.vue?vue&type=script&lang=js&"
export * from "./AppSidebarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports